const scriptTag = document.createElement('script');
scriptTag.src = "https://cdn.mazing.link/mzg-in.js";
scriptTag.type = "text/javascript";
scriptTag.crossOrigin = "anonymous";
scriptTag.defer = true;
document.head.append(scriptTag);

let currentProduct;
let iframeSrc;
let iframeElement;
let customer = 'ANDYCOLLEY14GMAILCOM';

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};

const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '').pop();
    const productParts = product.split('?');
    currentProduct = `${productParts[0]}`;
    console.log('Final SKU:', currentProduct.toLowerCase());
    return currentProduct.toLowerCase();
};

const cloneAndReplaceThumbGallery = (thumbGallery) => {
    const cloned = thumbGallery.cloneNode(true);
    thumbGallery.parentNode.replaceChild(cloned, thumbGallery);
    return cloned;
};

const cloneAndInsertThumb = (thumbGallery, newImgSrc) => {
    const firstThumb = thumbGallery.children[0];
    if (!firstThumb) return;

    const clonedThumb = firstThumb.cloneNode(true);
    clonedThumb.id = 'mazing-thumb';
    clonedThumb.setAttribute('aria-current', 'false');

    const originalImg = clonedThumb.querySelector('img');
    if (!originalImg) return;

    originalImg.style.opacity = '0.4';
    originalImg.style.filter = 'brightness(120%) grayscale(100%)';
    originalImg.style.zIndex = '1';
    originalImg.style.position = 'relative';

    clonedThumb.style.position = 'relative';

    const overlayWrapper = document.createElement('div');
    overlayWrapper.style.position = 'absolute';
    overlayWrapper.style.top = '0';
    overlayWrapper.style.left = '0';
    overlayWrapper.style.width = '100%';
    overlayWrapper.style.height = '100%';
    overlayWrapper.style.padding = '5%';
    overlayWrapper.style.boxSizing = 'border-box';
    overlayWrapper.style.zIndex = '2';
    overlayWrapper.style.pointerEvents = 'none';

    const overlayImg = document.createElement('img');
    overlayImg.src = newImgSrc;
    overlayImg.id = 'mazing-img';
    overlayImg.style.width = '100%';
    overlayImg.style.height = '100%';
    overlayImg.style.padding = '10%';
    overlayImg.style.objectFit = 'contain';
    overlayImg.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';

    overlayWrapper.appendChild(overlayImg);
    clonedThumb.appendChild(overlayWrapper);

    if (thumbGallery.children.length > 1) {
        thumbGallery.insertBefore(clonedThumb, thumbGallery.children[1]);
    } else {
        thumbGallery.appendChild(clonedThumb);
    }
};

const insertIframe = (imgGallery, iframeSrc) => {
    const firstItem = imgGallery.children[0];
    if (!firstItem) return;

    const clonedItem = firstItem.cloneNode(true);
    clonedItem.id = 'mazing-iframe-item';
    clonedItem.classList.remove('is-initial');
    clonedItem.setAttribute('data-media-id', 'mazing-iframe-item');

    const img = clonedItem.querySelector('img');
    iframeElement = document.createElement('iframe');
    iframeElement.src = iframeSrc;
    iframeElement.width = '100%';
    iframeElement.height = '100%';
    iframeElement.style.border = 'none';
    iframeElement.setAttribute('allowusermedia', '');
    iframeElement.setAttribute('allowfullscreen', '');
    iframeElement.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;";

    img.replaceWith(iframeElement);

    if (imgGallery.children.length > 1) {
        imgGallery.insertBefore(clonedItem, imgGallery.children[1]);
    } else {
        imgGallery.appendChild(clonedItem);
    }
};

const setupThumbClickListeners = (thumbGallery, imgGallery) => {
    const thumbs = Array.from(thumbGallery.children);
    const items = Array.from(imgGallery.children);

    thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            thumbs.forEach(t => t.setAttribute('aria-current', 'false'));

            const targetItem = items[i];
            if (targetItem) {
                const offsetLeft = targetItem.offsetLeft;
                imgGallery.scrollTo({
                    left: offsetLeft,
                    behavior: 'smooth'
                });
                await waitForScrollToFinish(imgGallery, offsetLeft);
            }

            requestAnimationFrame(() => {
                thumbs.forEach(t => t.setAttribute('aria-current', 'false'));
                thumb.setAttribute('aria-current', 'true');
            });
        });
    });
};

const waitForScrollToFinish = (container, targetScrollLeft, timeout = 1000) => {
    return new Promise((resolve) => {
        const startTime = Date.now();
        const checkScroll = () => {
            const now = Date.now();
            const currentScroll = container.scrollLeft;
            const diff = Math.abs(currentScroll - targetScrollLeft);

            if (diff < 2 || now - startTime > timeout) {
                requestAnimationFrame(() => resolve());
            } else {
                requestAnimationFrame(checkScroll);
            }
        };
        checkScroll();
    });
};

const setupViewerVisibilityObserver = (imgGallery) => {
    const viewerItem = document.getElementById('mazing-iframe-item');
    const zoomButton = document.querySelector('.product-gallery__zoom-button');

    if (!viewerItem || !zoomButton) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.target === viewerItem) {
                if (entry.isIntersecting) {
                    zoomButton.style.display = 'none';
                } else {
                    zoomButton.style.display = '';
                }
            }
        });
    }, {
        root: imgGallery,
        threshold: 0.6
    });

    observer.observe(viewerItem);
};


const syncIframeHeight = (imgGallery) => {
    const iframeItem = document.getElementById('mazing-iframe-item');
    if (!imgGallery || !iframeItem) return;

    const firstItem = imgGallery.children[0];
    if (!firstItem) return;

    const firstItemHeight = firstItem.offsetHeight;
    iframeItem.style.height = `${firstItemHeight}px`;
};

const initializeMazing = async () => {
    const imgGallery = await waitForElement('.product-gallery__carousel');
    let thumbGallery = await waitForElement('.product-gallery__thumbnail-scroller');

    const myImageSrc = 'https://cdn.mazing.link/assets/svg/3D.svg';

    iframeSrc = await mazingProjectAvailable({
        customerName: customer,
        getSKU: getCurrentSKU,
    });

    if (!iframeSrc) {
        console.log('iframeSrc not found, aborting script execution.');
        return;
    }

    insertIframe(imgGallery, iframeSrc);
    syncIframeHeight(imgGallery);

    cloneAndInsertThumb(thumbGallery, myImageSrc);
    thumbGallery = cloneAndReplaceThumbGallery(thumbGallery);

    setupThumbClickListeners(thumbGallery, imgGallery);

    console.log('Mazing initialized with clean DOM.');

    setupViewerVisibilityObserver(imgGallery);
};

// Start
const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');
        await initializeMazing();
        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};
initializeScript();
